import { callProxy } from "./api";

export async function fetchApartmentBySlug(slug, token) {
  return callProxy(`/api/properties/${slug}`, token);
}

export async function fetchApartments(token) {
  return callProxy(`/api/properties`, token);
}


/* =========================
   ❤️ LIKE / UNLIKE APARTMENT
   (same pattern as packages)
========================= */

export async function likeApartment(slug) {
  const visitorId = localStorage.getItem("visitorId");

  return callProxy(
    `/api/properties/${slug}/like`,
    null,
    {
      method: "POST",
      body: { visitorId },
    }
  );
}

